// Mensagem de limite do plano com link para trocar de plano.
import { Link } from 'react-router-dom'
import { ApiError } from '../../lib/api'

export function isPlanLimit(err: unknown) {
  return err instanceof ApiError && err.code === 'plan_limit'
}

export default function UpgradeHint({ accountId, message, canBill }: { accountId: string; message: string; canBill: boolean }) {
  return (
    <div className="callout amber" role="alert">
      <span>
        {message}{' '}
        {canBill ? <Link className="strong" style={{ color: 'var(--primary)' }} to={`/app/conta/${accountId}/plano`}>Ver planos</Link> : 'Fale com o dono da conta para mudar de plano.'}
      </span>
    </div>
  )
}
